import { defineComponent } from 'vue';
export default defineComponent({
    name: 'WaitLockModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        time: {
            type: String,
            default: ''
        }
    },
    setup(props, cxt) {
        const stopPopup = event => {
            event.stopPropagation();
            event.preventDefault();
        };
        const closeModal = () => {
            cxt.emit('close', false);
        };
        return {
            closeModal,
            stopPopup
        };
    }
});
